import toast from 'react-hot-toast';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { mainCategoryServices } from '../services/main-category.service';

export const useDeleteMainCategory = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: mainCategoryServices.softDeleteMainCategory,
    onSuccess: () => {
      queryClient.invalidateQueries(['main-category']);
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || 'Failed to delete main category');
    },
  });
};
